import App from '@/models/App'
import OrderingOrdererShip from '@/models/OrderingOrdererShip'
import OrderingOrdererItemTopCategory from '@/models/OrderingOrdererItemTopCategory'
import OrderingOrdererItemCategory from '@/models/OrderingOrdererItemCategory'
import OrderingOrdererItemSubCategory from '@/models/OrderingOrdererItemSubCategory'
import OrderingOrdererItemImage from '@/models/OrderingOrdererItemImage'

export default class OrderingOrdererItem extends App {
    static get entity() {
        return 'OrderingOrdererItems'
    }

    static all() {
        return this.query()
            .with('orderingShip')
            .with('orderingItemTopCategory')
            .with('orderingItemCategory')
            .with('orderingItemSubCategory')
            .with('orderingItemImages')
            .get()
    }

    static find(id) {
        return this.query()
            .with('orderingShip')
            .with('orderingItemTopCategory')
            .with('orderingItemCategory')
            .with('orderingItemSubCategory')
            .with('orderingItemImages')
            .where('id', id)
            .first()
    }

    static fields() {
        return {
            id: this.attr(''),
            orderingShipId: this.attr(''),
            orderingItemTopCategoryId: this.attr(''),
            orderingItemCategoryId: this.attr(''),
            orderingItemSubCategoryId: this.attr(''),
            name: this.attr(''),
            impaCode: this.attr(''),
            remark: this.attr(''),
            stock: this.attr(''),
            alert: this.attr(''),
            unit: this.attr(''),
            createdAt: this.attr(''),
            updatedAt: this.attr(''),
            orderingShip: this.belongsTo(OrderingOrdererShip, 'orderingShipId'),
            orderingItemTopCategory: this.belongsTo(
                OrderingOrdererItemTopCategory,
                'orderingItemTopCategoryId'
            ),
            orderingItemCategory: this.belongsTo(
                OrderingOrdererItemCategory,
                'orderingItemCategoryId'
            ),
            orderingItemSubCategory: this.belongsTo(
                OrderingOrdererItemSubCategory,
                'orderingItemSubCategoryId'
            ),
            orderingItemImages: this.hasMany(
                OrderingOrdererItemImage,
                'orderingItemId',
                'id'
            ),
            orderingOrderItems: this.attr(''),
        }
    }

    static apiConfig = {
        actions: {
            fetch(orderingShipId, params) {
                return this.get(`/ordering/orderer/${orderingShipId}/items`, {
                    params: App.get(params),
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            find(orderingShipId, orderingItemId, params) {
                return this.get(
                    `/ordering/orderer/${orderingShipId}/items/${orderingItemId}`,
                    {
                        params: App.get(params),
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        dataKey: 'data',
                        baseURL: App.apiURL(),
                    }
                )
            },
            create(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/items`,
                    App.post(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            update(orderingShipId, orderingItemId, params) {
                return this.patch(
                    `/ordering/orderer/${orderingShipId}/items/${orderingItemId}`,
                    App.patch(params),
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(orderingShipId, orderingItemId) {
                return this.delete(
                    `/ordering/orderer/${orderingItemId}/items/${orderingItemId}`,
                    {
                        params: {},
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        delete: orderingItemId,
                        baseURL: App.apiURL(),
                    }
                )
            },
            import(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/items/import`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            export(orderingShipId, params) {
                return this.post(
                    `/ordering/orderer/${orderingShipId}/items/export`,
                    App.post(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        responseType: 'arraybuffer',
                        baseURL: App.apiURL(),
                    }
                )
            },
        },
    }
}
